import * as React from "react";
import { IconType } from "react-icons/lib/esm/iconBase";
import styled, { StyledComponent, DefaultTheme } from "styled-components";
import colors from "../../../styles/colors";
import fontSizes from "../../../styles/fontSizes";
import ClickableElement from "../../utils/ClickableElement";

export interface IActionConfirmationButtonProps {
  action: string;
  actionColor?: string;
  actionFn: () => void;
  ActionIcon: IconType;
  CustomActionButton?: StyledComponent<"button", DefaultTheme, {}, never>;
  customBtnText?: string;
}

export interface IDeleteConfirmationButtonState {
  confirm: boolean;
}

export const ActionButton = styled(ClickableElement)`
  align-items: center;
  display: flex;
  justify-content: space-around;
  font-size: ${fontSizes.smallButton};
  width: inherit;

  &:hover {
    transition: color 0.25s;
    color: ${colors.red};
  }
`;

const ButtonContainer = styled.div`
  background-color: transparent;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0rem 0.5rem;
`;

interface IActionButtonProps {
  actionColor?: string;
}

const CommitActionButton = styled(ClickableElement)<IActionButtonProps>`
  background: ${props => props.actionColor || colors.darkred};
  color: white;
  border: inherit;
  cursor: pointer;
  font-size: ${fontSizes.smallButton};
`;

const CancelButton = styled(ClickableElement)`
  background: ${colors.darkgrey};
  color: white;
  border: none;
  cursor: pointer;
  font-size: ${fontSizes.smallButton};
`;

export const ActionButtonContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-around;
  width: auto;
  padding-left: 2rem;
`;

export const InstructionActionButtonContainer = styled(ActionButtonContainer)`
  padding-right: 2rem;
`;

export default class ActionConfirmationButton extends React.Component<
  IActionConfirmationButtonProps,
  IDeleteConfirmationButtonState
> {
  constructor(props: IActionConfirmationButtonProps) {
    super(props);
    this.state = {
      confirm: false,
    };
  }

  public render() {
    const { ActionIcon } = this.props;

    const ActButton = this.props.CustomActionButton ?? ActionButton;

    return this.state.confirm ? (
      <ButtonContainer>
        <CommitActionButton actionColor={this.props.actionColor} onClick={this.commitAction}>
          {this.props.action}
        </CommitActionButton>
        <CancelButton onClick={this.cancel}>Cancel</CancelButton>
      </ButtonContainer>
    ) : (
      <ActButton onClick={this.confirm} aria-label="delete">
        <ActionIcon />
        {this.props.customBtnText}
      </ActButton>
    );
  }

  private commitAction = (e: React.MouseEvent) => {
    this.props.actionFn();
    this.setState({
      confirm: false,
    });
  };

  private confirm = (e: React.MouseEvent) => {
    this.setState({
      confirm: true,
    });
  };

  private cancel = (e: React.MouseEvent) => {
    this.setState({
      confirm: false,
    });
  };
}
